// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Layout5-bannerLayoutContainer-kKWYm {
    min-height: 768px;
    height: auto;
    position: relative;
    background: var(--secondary-gray-bg);
}

.Layout5-bannerBackgroundImage-oHwst {
    background-size: cover;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    right: 0;
    -o-object-fit: cover;
       object-fit: cover;
    background-repeat: no-repeat;
    background-position: top center;
    -webkit-transition: all 0.1s ease;
    transition: all 0.1s ease;
}

.Layout5-searchFormContainer-hmKqv {
    position: relative;
    height: 100%;
    margin: 0 auto;
    max-width: 1250px;
    padding: 250px 15px 100px;
}

.Layout5-bannerCaptionText-CQEKR {
    font-size: 60px;
    line-height: 65px;
    padding-top: 8px;
    padding-bottom: 8px;
    color: var(--common-primary-white-foreground);
    margin: 30px 0 45px;
    font-weight: 600;
    text-shadow: 0 2px 2em var(--primary-box-shadow);
    text-align: center;
}

.Layout5-bannerCaptionHighlight-lHD9v {
    font-weight: 700;
    color: var(--primary-bg);
}

.Layout5-imageCss-KlRXN {
    width: 100%;
    border-radius: 15px;
    margin-top: 35px;
}

.Layout5-positionRelative-PZ29Y {
    position: relative;
}

@media screen and (max-width: 1200px) {
    .Layout5-bannerCaptionText-CQEKR {
        padding-top: 50px;
    }
}

@media screen and (max-width: 767px) {
    .Layout5-searchFormWrap-raJZn {
        padding: 20px;
    }

    .Layout5-bannerCaptionText-CQEKR {
        font-size: 32px;
        line-height: 36px;
        bottom: -115px;
    }

    .Layout5-searchFormContainer-hmKqv {
        padding: 135x 15px 100px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Home/Layout5/Layout5.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,kBAAkB;IAClB,QAAQ;IACR,oBAAiB;OAAjB,iBAAiB;IACjB,4BAA4B;IAC5B,+BAA+B;IAC/B,iCAAyB;IAAzB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,6CAA6C;IAC7C,mBAAmB;IACnB,gBAAgB;IAChB,gDAAgD;IAChD,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,wBAAwB;IAC5B;AACJ","sourcesContent":[".bannerLayoutContainer {\n    min-height: 768px;\n    height: auto;\n    position: relative;\n    background: var(--secondary-gray-bg);\n}\n\n.bannerBackgroundImage {\n    background-size: cover;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    position: absolute;\n    right: 0;\n    object-fit: cover;\n    background-repeat: no-repeat;\n    background-position: top center;\n    transition: all 0.1s ease;\n}\n\n.searchFormContainer {\n    position: relative;\n    height: 100%;\n    margin: 0 auto;\n    max-width: 1250px;\n    padding: 250px 15px 100px;\n}\n\n.bannerCaptionText {\n    font-size: 60px;\n    line-height: 65px;\n    padding-top: 8px;\n    padding-bottom: 8px;\n    color: var(--common-primary-white-foreground);\n    margin: 30px 0 45px;\n    font-weight: 600;\n    text-shadow: 0 2px 2em var(--primary-box-shadow);\n    text-align: center;\n}\n\n.bannerCaptionHighlight {\n    font-weight: 700;\n    color: var(--primary-bg);\n}\n\n.imageCss {\n    width: 100%;\n    border-radius: 15px;\n    margin-top: 35px;\n}\n\n.positionRelative {\n    position: relative;\n}\n\n@media screen and (max-width: 1200px) {\n    .bannerCaptionText {\n        padding-top: 50px;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .searchFormWrap {\n        padding: 20px;\n    }\n\n    .bannerCaptionText {\n        font-size: 32px;\n        line-height: 36px;\n        bottom: -115px;\n    }\n\n    .searchFormContainer {\n        padding: 135x 15px 100px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bannerLayoutContainer": `Layout5-bannerLayoutContainer-kKWYm`,
	"bannerBackgroundImage": `Layout5-bannerBackgroundImage-oHwst`,
	"searchFormContainer": `Layout5-searchFormContainer-hmKqv`,
	"bannerCaptionText": `Layout5-bannerCaptionText-CQEKR`,
	"bannerCaptionHighlight": `Layout5-bannerCaptionHighlight-lHD9v`,
	"imageCss": `Layout5-imageCss-KlRXN`,
	"positionRelative": `Layout5-positionRelative-PZ29Y`,
	"searchFormWrap": `Layout5-searchFormWrap-raJZn`
};
module.exports = ___CSS_LOADER_EXPORT___;
